import React from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import IdleTimer from 'react-idle-timer';
import { Switch, Route } from 'react-router-dom';
import ReactAI from 'react-appinsights';
import Tour from 'reactour';
import { Button } from 'devextreme-react';
import routes from '../../config/routes';
import MenuLateral from '../MenuLateral/view';
import Header from '../Header/view';
import { logout, doRefreshToken } from '../Acceso/Login/actions';
import { getTokenPowerBi } from './Graficos/actions';
import PdfTemplates from '../Pdf/pdfTemplates';
import { openCloseAcountMenu } from '../Header/actions';
import { setExpanded, openCloseTour } from '../Global/actions';
import TourConfirmationModal from '../Shared/tourConfirmationModal';
import { setPopOverStatus } from '../Header/Notificaciones/actions';
import TourAchs from './Tours/TourAchs';
import TourEmpresa from './Tours/TourEmpresa';
import TourTrabajador from './Tours/TourTrabajador';
import { isIframe } from '../../helpers/isIframe';

const expandedMenuWidth = 290;
const collapsedMenuWidth = 70;
const menuBodySpace = 30;
const menuBodySpace2 = 10;

const thirteenMinutes = 780000;
const fifteenMinutes = 900000;
const thirtySeconds = 30000;

class SucrursalVirtual extends React.Component {
  constructor(props) {
    super(props);

    this.timerRef = React.createRef();

    this.state = {
      expanded: localStorage.getItem('expandedMenu') === 'true',
      allowExpand: true,
      menuWidth:
        localStorage.getItem('expandedMenu') === 'true' ? expandedMenuWidth : collapsedMenuWidth,
      headerHeight: 109,
    };
    props.dispatch(
      getTokenPowerBi(this.props.configPowerBI.groupId, this.props.configPowerBI.reportId),
    );

    this.tourConfig = TourAchs(this.props.dispatch);
  }

  componentDidMount = async () => {
    if (this.props.global && this.props.global.RUT && !isIframe) {
      const result = JSON.parse(sessionStorage.getItem('listaBlanca'));
      if (result.exist && !result.isACHS) {
        this.props.dispatch(logout());
      }
    }
    this.updateMenu();
    window.addEventListener('resize', this.updateMenu);
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.isOpenAccountMenu !== this.props.isOpenAccountMenu) {
      if (this.props.isOpenAccountMenu === true) {
        this.expandMenu();
      } else {
        this.handleCollapseMenu();
      }
    }

    if (!prevProps.tourConfirmationOpen && this.props.tourConfirmationOpen) {
      this.getTourConfig();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateMenu);
  };

  getTourConfig = () => {
    switch (this.props.userProfile) {
      case 'Empresa': {
        this.tourConfig = TourEmpresa(this.props.dispatch);
        break;
      }
      case 'Trabajador': {
        this.tourConfig = TourTrabajador(this.props.dispatch);
        break;
      }
      case 'Achs': {
        this.tourConfig = TourAchs(this.props.dispatch);
        break;
      }
      default:
        this.tourConfig = TourTrabajador(this.props.dispatch);
        break;
    }
  };

  closeTour = () => {
    if (!this.props.isExpanded) this.handleCollapseMenu();
    this.props.dispatch(openCloseTour(false));
    this.props.dispatch(setPopOverStatus(false));
  };

  updateMenu = () => {
    const size =
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const minWidth = 1360;
    if (size <= minWidth && this.state.allowExpand) {
      this.setState({ allowExpand: false, expanded: false, menuWidth: collapsedMenuWidth });
      localStorage.setItem('expandedMenu', false);
      this.props.dispatch(setExpanded(false));
    } else if (size > minWidth && !this.state.allowExpand) {
      localStorage.setItem('expandedMenu', true);
      this.setState({ allowExpand: true });
      this.props.dispatch(setExpanded(true));
    }
  };

  expandMenu = () => {
    this.props.dispatch(openCloseAcountMenu(true));
    this.setState({ expanded: true, menuWidth: expandedMenuWidth });
    localStorage.setItem('expandedMenu', true);
  };

  handleCollapseMenu = () => {
    this.props.dispatch(openCloseAcountMenu(false));
    this.setState({ expanded: false, menuWidth: collapsedMenuWidth });
    localStorage.setItem('expandedMenu', false);
  };

  handleUserIdle = () => {
    if (!isIframe) this.props.dispatch(logout());
  };

  handleResetTimer = () => {
    this.timerRef.reset();
  };

  handleUserAction = () => {
    if (this.timerRef.getElapsedTime() > thirteenMinutes) {
      this.props.dispatch(
        doRefreshToken(this.props.global, this.props.global.RefreshToken, this.handleResetTimer),
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        <TourConfirmationModal expandMenu={this.expandMenu} />
        <Tour
          steps={this.tourConfig}
          isOpen={this.props.isTourOpen}
          maskClassName='mask-tour'
          className='helper'
          startAt={0}
          disableDotsNavigation
          showNavigation={false}
          rounded={5}
          accentColor='#5cb7b7'
          onRequestClose={this.closeTour}
          nextButton={<Button text='Siguiente' type='success' />}
          prevButton={<Button text='Atrás' />}
          lastStepNextButton={<Button text='Finalizar' type='success' />}
        />
        <IdleTimer
          ref={(ref) => {
            this.timerRef = ref;
          }}
          onIdle={this.handleUserIdle}
          onAction={this.handleUserAction}
          throttle={thirtySeconds}
          timeout={fifteenMinutes}
        />
        <MenuLateral
          allowExpand={this.state.allowExpand}
          collapseMenu={this.handleCollapseMenu}
          expandMenu={this.expandMenu}
          isExpanded={this.state.expanded}
          width={this.state.menuWidth}
        />

        <Header height={this.state.headerHeight} menuWidth={this.state.menuWidth + menuBodySpace} />
        <div
          id='content'
          className='content-display'
          style={{ position: 'initial' }}
        >
          <div
            id='mainContent'
            className='zero row menu-animation-margin'
            style={{
              overflowY: 'auto',
              zIndex:
                this.props.showHideForm ||
                this.props.showHideFormSolicitud ||
                this.props.showHideFormCotizaciones
                  ? 300
                  : 10,
              marginLeft: this.state.menuWidth + menuBodySpace2,
            }}
          >
            <ConnectedRouter history={this.props.history}>
              <div>
                <Switch>
                  {routes.map((route) => (
                    <Route key={route.path} exact path={route.path} component={route.component} />
                  ))}
                </Switch>
              </div>
            </ConnectedRouter>
            <PdfTemplates />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  configPowerBI: state.graficos.config,
  isTourOpen: state.global.isTourOpen,
  data: state.login.data,
  global: state.global.userData,
  toast: state.global.toast,
  location: state.router.location,
  isOpenAccountMenu: state.header.isOpenAccountMenu,
  showHideForm: state.denuncias.showHideForm || state.prestacionesEmpresa.showHideForm,
  showHideFormSolicitud: state.solicitudesAgendaSel.showHideForm,
  showHideFormCotizaciones: state.cotizaciones.showHideFormCotizaciones,
  userProfile: state.global.userProfile,
  tourConfirmationOpen: state.global.tourConfirmationOpen,
  isExpanded: state.global.isExpanded,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SucrursalVirtual);
ReactAI.withTracking(SucrursalVirtual);
